export class AttachmentHelper {
  static formatHeaders(headers: string, fileType: string): Record<string, string> {
    if (!headers) {
      return null;
    }
    const headersRecord: Record<string, string> = headers
      .split(',')
      .reduce((headerRecord: Record<string, string>, currentHeader: string) => {
        const splitCurrentHeader: string[] = currentHeader.split(':');
        headerRecord[splitCurrentHeader[0]] = splitCurrentHeader[1];
        return headerRecord;
      }, {});
    headersRecord['Content-Type'] = fileType;
    return headersRecord;
  }
}
